import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { addBank, companyLogo, dataLoading } from "../../../assets/assets";
import { savePartnerData } from "../../../Redux/Slices/MainSlice";
import Autocomplete from "react-google-autocomplete";
import * as Yup from "yup";

import {
  AddBankAccountOnboarding,
  openStripeOnBoarding,
} from "../../../service/stripe.service";
import {
  accessTokenLogin,
  getStorageValue,
  getZipCode,
  zipObjectCovert,
} from "../../../service/shared.service";
import httpApiCall from "../../../service/api.service";
import { ErrorMessage, Field, Form, Formik, validateYupSchema } from "formik";
import toastr from "../../elements/toast";
import { formatDate2 } from "../../../utils/DateFormat";

const Bank = () => {
  const toastrService = new toastr(true);
  const mapApiKey = getStorageValue("map_api_key");
  const navigate = useNavigate();
  const [sppiner, setSppiner] = useState(false);
  let partnerData: any = getStorageValue('partnerData');
  const userData = useSelector((state: any) => {
    const partnerData = state?.APIData?.partnerData;
    return partnerData && [partnerData].length > 0 ? partnerData : null;
  });
  const dispatch = useDispatch();
  const [queryParameters] = useSearchParams();
  const stripeData = userData && userData.stripe_data;
  const [shimmerEffect, setShimmerEffect] = useState(true);
  const [values, setValues] = useState({
    accountType: "",
    accountName: "",
    routingNumber: "",
    accountNumber: "",
    ssn: "",
    dob: "",
    address: "",
    zip: "",
    state: "",
    city: "",
  });
  const [country_code, setCountryCode] = useState(partnerData && partnerData.country_currency_info && partnerData.country_currency_info.country ? partnerData.country_currency_info.country['country_code'] : 'US');
  const [hidezipCode, setHidezipCode] = useState(false);

  useEffect(() => {
    setSppiner(true);

    callApi();
    if (userData && userData.country_code) {
      let countries = [];
        countries.push(userData.country_code);
        const US_UT_country_codes = ['VI', 'PR', 'GU', 'AS', 'MP'];
        if (userData.country_code == 'US') {
          countries = [...countries, ...US_UT_country_codes];
        }

      setCountryCode(countries);
    }
  }, [stripeData]);
  const callApi = async () => {
    if (queryParameters && queryParameters.get("id")) {
      const id = queryParameters.get("id");
      queryParameters.delete("id");
      // window.history.replaceState({}, "", "app/profile");
      const partnerData = await AddBankAccountOnboarding(id);
      if (partnerData && !partnerData.is_error) {
        dispatch(savePartnerData(partnerData));
        window.location.href =
          window.location.origin + "/partner/app/profile";
        setSppiner(false);
      }
      setStripeValues();
    } else {
      setStripeValues();
      setSppiner(false);
    }
    setShimmerEffect(false);
  };

  const setStripeValues = async () => {
    if (stripeData && stripeData.bank_info) {
      if (stripeData && stripeData?.dob) {
        setValues((data:any) => ({
          ...data,
          dob:
          (stripeData &&
            String(stripeData?.dob.day).padStart(2, '0') +
            "/" +
            String(stripeData.dob.month).padStart(2, '0') +
            "/" +
            stripeData?.dob.year) ||
          "",
        }))
      }
      setValues((data: any) => ({
        ...data,
        accountType: stripeData?.account_type || "",
        accountName:
          stripeData?.bank_info[0]?.account_holder_name ||
          stripeData?.account_name ||
          "",
        routingNumber:
          (stripeData &&
            "*****" + stripeData?.bank_info[0]?.routing_number.substring(5)) ||
          "",
        accountNumber:
          (stripeData && "*****" + stripeData?.bank_info[0]?.last4) || "",
        ssn: "*****",
        address:
          stripeData.account_type == "individual"
            ? stripeData && stripeData?.individual_address?.line1
            : (stripeData && stripeData.company_address?.line1) || "",
        zip:
          stripeData.account_type == "individual"
            ? stripeData && stripeData?.individual_address?.postal_code
            : (stripeData && stripeData?.company_address?.postal_code) || "",
        state:
          stripeData.account_type == "individual"
            ? stripeData && stripeData?.individual_address?.state
            : (stripeData && stripeData?.company_address?.state) || "",
        city:
          stripeData.account_type == "individual"
            ? stripeData && stripeData?.individual_address?.city
            : (stripeData && stripeData?.company_address?.city) || "",
      }));
      if (stripeData.individual_address_verified == 1) {
        let addreesObj = stripeData.individual_address;
        // console.log(addreesObj, "addreesObj");
      }
    }
  };
  const validationSchema = Yup.object().shape({
    // address: Yup.string().required("Address is required"),
    address: Yup.string().when([], (i, schema) => {
      return !values.address
        ? schema.required("Address is required")
        : schema.notRequired();
    }),
    zip: Yup.string().when([], (i, schema) => {
      return !values.zip
        ? schema.required("Zip is required")
        : schema.notRequired();
    }),
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const placeSelectedZip = async (place: any, setFieldValue: any) => {
    setHidezipCode(true);
    const placeData = await getZipCode( zipObjectCovert(place));
    setFieldValue("zip", placeData.zip)
    if (placeData) {
      values.zip = placeData.zip
      values.city = placeData.city
      values.state = placeData.state_name
    // setTimeout(() => {
      //   setFieldValue({
      //     city: placeData.city,
      //     state: placeData.state_name,
      //     zip: placeData.zip,
      //   })
      // }, 0)
      setValues((prevValues) => ({
        ...prevValues,
        zip: placeData.zip,
        city: placeData.city,
        state: placeData.state_name,
      }));

    }
    setHidezipCode(false);
  };

  const handleSubmit = async () => {
    setSppiner(true);
    const token = getStorageValue("partnerToken");
    const body = {
      access_token: token,
      individual_address: JSON.stringify({
        line1: values.address,
        postal_code: values.zip,
        state: values.state,
        city: values.city,
      }),
    };

    const companyData = {
      ...body,
      company_address: JSON.stringify({
        line1: values.address,
        postal_code: values.zip,
        state: values.state,
        city: values.city,
      }),
    };
    try {
      const data = await httpApiCall({
        api: "upload_partner_document",
        type: "form",
        body: stripeData.account_type == "company" ? companyData : body,
      });
      setSppiner(false);
      if (data && data.is_error === 0) {
        // console.log(data);
        accessTokenLogin();
        toastrService.showSuccess("Update Successfully");
      } else {
        toastrService.showError(data.original_text || data.err);
      }
    } catch (error) {
      console.log("Error in API call:", error);
      toastrService.showError(
        "An error occurred while processing your request."
      );
    }
  };
 

  return (
    <>
    <div className="row">
      <div className=" col-12 col-xl-9 bank_support">
      <div className="bank">
        <div className="bank-header">
          <h1>Bank Information</h1>
        </div>
        <div>
          {userData &&
            userData.partner_profile &&
            userData.partner_profile[0] &&
            !userData.partner_profile[0].stripe_account_id && (
              <>
              <div>
                <img src={addBank} alt="" />
              </div>
                                   <p>You need to add bank to get your commissions</p>

                <div className="add-account">
                  <button
                    disabled={shimmerEffect}
                    className="btn-button"
                    onClick={() => (
                      openStripeOnBoarding(),
                      setShimmerEffect(true),
                      setTimeout(() => {
                        setShimmerEffect(false);
                      }, 5000)
                    )}
                  >
                    <span className="d-flex align-items-center ">
                      {" "}
                      + Add Account
                      {shimmerEffect && (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="ms-2"
                        />
                      )}
                    </span>
                  </button>
                </div>
              </>
            )}

          {userData &&
            userData.partner_profile &&
            userData.partner_profile[0] &&
            userData.partner_profile[0].stripe_account_id && (
              <div>
                <Formik
                  initialValues={values}
                  onSubmit={handleSubmit}
                  validationSchema={validationSchema}
                >
                  {({ setFieldValue }) => (
                    <Form>
                      <div className="row bank_information">
                        <div className="col-lg-6 col-12">
                          <div className="my-3">
                            <label htmlFor="" className="bank_label">Account Type</label>
                            <Field
                             id="account_type"
                              type="text"
                              className="form-control text-capitalize"
                              value={values.accountType}
                              disabled
                              name="accountType"
                              onChange={(e: any) => handleInputChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-12">
                          <div className="my-3">
                            <label htmlFor="" className="bank_label">Account Holder Name</label>
                            <Field
                              type="text"
                              id="account_holder_name"
                              className="form-control"
                              value={values.accountName}
                              disabled
                              name="accountName"
                              onChange={(e: any) => handleInputChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-12">
                          <div className="my-3">
                            <label htmlFor="" className="bank_label">Routing Number</label>
                            <Field
                              type="text"
                              id="routeingNum "
                              className="form-control"
                              value={values.routingNumber}
                              disabled
                              name="rountingNumber"
                              onChange={(e: any) => handleInputChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-12">
                          <div className="my-3">
                            <label htmlFor="" className="bank_label">Account Number</label>
                            <Field
                              type="text"
                              id="account_number"
                              className="form-control"
                              value={values.accountNumber}
                              disabled
                              name="accountNumber"
                              onChange={(e: any) => handleInputChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-12">
                          <div className="my-3">
                            <label htmlFor="" className="bank_label">
                              {userData &&
                                userData.country_currency_info &&
                                userData.country_currency_info.country &&
                                userData.country_currency_info.country
                                ? userData.country_currency_info.country
                                  .identity_label
                                : "SSN"}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={values.ssn}
                              disabled={stripeData.ssn_verified == 1}
                              name="ssn"
                              id="ssn_verified"
                              onChange={(e: any) => handleInputChange(e)}
                            />
                          </div>
                        </div>
                        {stripeData.account_type == "individual" && (
                          <div className="col-lg-6 col-12">
                            <div className="my-3">
                              <label htmlFor="" className="bank_label">Date of Birth</label>
                              <Field
                                type="text"
                                className="form-control"
                                value={formatDate2(values.dob)}
                                disabled={stripeData.dob_verified == 1}
                                name="dob"
                                id="dob"
                                onChange={(e: any) => handleInputChange(e)}
                              />
                            </div>
                          </div>
                        )}
                        {stripeData.account_type == "company" && (
                          <div className="col-lg-6 col-12">
                            <div className="my-3">
                              <label htmlFor="" className="bank_label">Company Name</label>
                              <Field
                                type="text"
                                className="form-control"
                                value={stripeData.company_name}
                                disabled
                                name="cName"
                                id="cName"
                                onChange={(e: any) => handleInputChange(e)}
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-lg-6 col-12">
                          <div className="my-3">
                            <label htmlFor="Address" className="bank_label">
                              {stripeData &&
                                stripeData.account_type == "company"
                                ? "Company Address"
                                : "Address"}{" "}
                            </label>
                            <Field
                              type="text"
                              id="c_address"
                              className="form-control"
                              value={values.address}
                              name="address"
                              disabled={
                                stripeData.account_type == "company"
                                  ? stripeData.company_address_verified == 1
                                  : stripeData.individual_address_verified == 1
                              }
                              onChange={(e: any) => {
                                handleInputChange(e)
                                setFieldValue("address", values.address)
                              }}
                            />
                            <ErrorMessage
                              name="address"
                              component="address"
                              className="text-danger m-2"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-12">
                          <div className="postal-code">
                            <label htmlFor="postalCode" className="bank_label">ZipCode</label>
                            {country_code && (<div style={{ 'border': 'solid 1px #dee2e6', 'borderRadius': '0.375rem', 'minHeight': '42px' }}>
                              {!hidezipCode && <Autocomplete
                                apiKey={mapApiKey}
                                className="form-control"
                                disabled={stripeData.account_type == "company" ? stripeData.company_address_verified == 1 : stripeData.individual_address_verified == 1}

                                style={{
                                  width: "100%",
                                  height: "40px",
                                  paddingLeft: "16px",
                                }}
                                onPlaceSelected={(place: any) => {
                                  placeSelectedZip(place, setFieldValue);
                                }}
                                options={{
                                  fields: [
                                    "address_components",
                                    "adr_address",
                                    "geometry",
                                    "name",
                                    "formatted_address",
                                  ],
                                  types: ["(regions)"],
                                  componentRestrictions: { country: country_code },
                                }}
                                defaultValue={values && values.zip}
                              />}
                            </div>
                            )}
                            <ErrorMessage
                              name="zip"
                              component="small"
                              className="text-danger m-2"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-12">
                          <div className="my-3">
                            <label htmlFor="" className="bank_label">City</label>
                            <Field
                              type="text"
                              className="form-control"
                              value={values.city}
                              name="city"
                              id="city"
                              disabled
                            />
                          </div>
                          <ErrorMessage
                            name="city"
                            component="small"
                            className="text-danger m-2"
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <div className="my-3">
                            <label htmlFor="" className="bank_label">State</label>
                            <Field
                              type="text"
                              id="state"
                              className="form-control"
                              value={values.state}
                              name="state"
                              disabled
                            />
                            <ErrorMessage
                              name="state"
                              component="small"
                              className="text-danger m-2"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="docs mt-3">
                        {stripeData.front_document_provided == 1 && (
                          <div className="document-upload">
                            <p>Photo ID (Front)</p>
                            <div className="upload-img">Provided</div>
                          </div>
                        )}
                        {stripeData.back_document_provided == 1 && (
                          <div className="document-upload">
                            <p>Photo ID (Back)</p>
                            <div className="upload-img">Provided</div>
                          </div>
                        )}
                      </div>
                      {stripeData &&
                        (stripeData.individual_address_verified != 1 ||
                          stripeData.company_address_verified != 1) && (
                          <div className="mt-4">
                            <button type="submit">
                              Update{" "}
                              {sppiner && (
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              )}
                            </button>
                          </div>
                        )}
                    </Form>
                  )}
                </Formik>
              </div>
            )}
        </div>
      </div>
      </div>
      <div className=" col-12 col-xl-3">

         { userData && userData.partner_profile && userData.partner_profile[0].stripe_account_id && <div className="mt-5">
        <p>For any changes in your bank details please contact our customer support at <Link id="supportLink" to="mailto:support@Credee.com" target="_blank">support@Credee.com</Link>
          </p>

        </div>}
        
      </div>
    </div>
      
    </>
  );
};

export default Bank;
